/**
 * @module
 * @description Javascript specific to the sticky header
 */

import * as tools from '@utils/tools';
import { on } from '@utils/events';

// Custom debounce function
const debounce = (func, wait = 50) => {
	let timeout;
	return function executedFunction(...args) {
		const later = () => {
			clearTimeout(timeout);
			func(...args);
		};
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
	};
};

const el = {
	container: tools.getNodes('masthead')[0],
	stickyScrollTarget: tools.getNodes('sticky-scroll-target')[0],
	stickyHeader: tools.getNodes('sticky-header')[0],
};

/**
 * @function getElementPosition
 * @description Get element's position in viewport
 */

const getElementPosition = (elem) => {
	const distance = elem.getBoundingClientRect();

	return distance.bottom <= 100;
};

/**
 * @function addClassOnScroll
 * @description Add class when page is scrolled
 */

const addClassOnScroll = () => {
	el.stickyHeader.classList.add('is-stuck');
	el.stickyHeader.setAttribute('aria-hidden', 'false');
};

/**
 * @function removeClassOnScroll
 * @description Remove class when page is scrolled
 */

const removeClassOnScroll = () => {
	el.stickyHeader.classList.remove('is-stuck');
	el.stickyHeader.setAttribute('aria-hidden', 'true');
};

/**
 * @function toggleClass
 * @description Toggles the sticky class when target el has scrolled out of viewport
 */

const toggleClass = () => {
	if (getElementPosition(el.stickyScrollTarget)) {
		addClassOnScroll();
	} else {
		removeClassOnScroll();
	}
};

/**
 * @function bindEvents
 * @description Bind the events for this module here.
 */

const bindEvents = () => {
	on(window, 'scroll', debounce(toggleClass));
};

/**
 * @function init
 * @description Kick off this modules functions
 */

const init = () => {
	if (!el.container) {
		return;
	}

	if (!el.stickyScrollTarget || !el.stickyHeader) {
		return;
	}

	bindEvents();
};

export default init;
